// Zentrale frische Bestätigung (docs/anmeldung/SPEZIFIKATION.md §6.4, A7): Seit der Dispatcher für JEDEN Vertrag mit
// `effects.securitySensitive` eine Bestätigung DIESER Sitzung verlangt (Kundendaten ändern, Monat wieder öffnen,
// Kasse einrichten …), fragt die API-Schicht selbst nach: `useActionMutation` ruft bei `reauth_required`
// `requestReauth()`, der eine Dialog der Anwendung (`<ReauthHost />` in web/shell/runtime.tsx) fragt Kennwort oder Code ab,
// danach läuft derselbe Aufruf mit demselben Idempotenzschlüssel noch einmal. Ohne Host (Komponententests, Schaukasten)
// antwortet `requestReauth()` sofort mit false – der Fehler bleibt dann, wie er ist.
//
// Kein React hier: hooks.ts importiert diese Datei, der Dialog selbst steht in Reauth.tsx.

export interface ReauthRequest {
  readonly id: number
  readonly message?: string
  resolve(confirmed: boolean): void
}

let current: ReauthRequest | null = null
let counter = 0
let hosts = 0
const listeners = new Set<() => void>()
const notify = (): void => {
  for (const listener of listeners) listener()
}

/** Bestätigung anfordern; true = bestätigt (Aufruf wiederholen), false = abgebrochen oder kein Dialog vorhanden. */
export function requestReauth(message?: string): Promise<boolean> {
  if (hosts === 0) return Promise.resolve(false)
  return new Promise<boolean>((resolve) => {
    // eine zweite Anfrage, während der Dialog offen ist, wartet auf dieselbe Antwort
    const previous = current
    const id = ++counter
    current = {
      id,
      message,
      resolve: (confirmed) => {
        previous?.resolve(confirmed)
        resolve(confirmed)
      },
    }
    notify()
  })
}

/** Für den Host: offene Anfrage beantworten */
export function resolveReauth(confirmed: boolean): void {
  const request = current
  current = null
  notify()
  request?.resolve(confirmed)
}

export const reauthStore = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  snapshot: (): ReauthRequest | null => current,
  /** der Host meldet sich an/ab – ohne Host gibt es keinen Dialog */
  attach(): () => void {
    hosts += 1
    return () => {
      hosts -= 1
      if (hosts === 0 && current) resolveReauth(false)
    }
  },
}
